export const StudentEditIcon = () => {
	return <svg width='17' height='19' viewBox='0 0 17 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M0.953068 17.796C1.18244 13.2843 4.49652 9.79602 8.4404 9.79602C12.3843 9.79602 15.6984 13.2843 15.9277 17.796H0.953068Z'
			fill='#0088CC' stroke='white'/>
		<circle cx='8.4404' cy='6.29602' r='5' fill='#0088CC' stroke='white' strokeWidth='2'/>
	</svg>;
};
